import produce from 'immer';
import { combineReducers } from 'redux';
import { AssistantRunActionType, AssistantRunAction } from '../../actions/assistantRunActions';

const loading = (state = false, action: AssistantRunAction) => {
  switch (action.type) {
    case AssistantRunActionType.LIST_ASSISTANT_RUNS:
    case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS:
      return true;
    case AssistantRunActionType.LIST_ASSISTANT_RUNS_OK:
    case AssistantRunActionType.LIST_ASSISTANT_RUNS_ERROR:
    case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS_OK:
    case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: AssistantRunAction) => {
  switch (action.type) {
    case AssistantRunActionType.LIST_ASSISTANT_RUNS:
    case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS:
      return '';
    case AssistantRunActionType.LIST_ASSISTANT_RUNS_ERROR:
    case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS_ERROR:
      return action.error;
    default:
      return state;
  }
};

type LoadingState = { loading: boolean; loadingError: string };
type DeletingState = { deleting: boolean; deletingError: string };

export type AssistantRunState = LoadingState & DeletingState;

type ActivityRunStateMap = {
  [id: string]: AssistantRunState;
};

const byId = (state: ActivityRunStateMap = {}, action: AssistantRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AssistantRunActionType.LIST_ASSISTANT_RUNS_OK: {
        action.data.data.forEach((assRun) => {
          draft[assRun.id] = {} as AssistantRunState;
        });

        break;
      }
      case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS_OK: {
        action.data.forEach((assRun) => {
          draft[assRun.id] = {} as AssistantRunState;
        });

        break;
      }
      case AssistantRunActionType.GET_ASSISTANT_RUN: {
        draft[action.assistantRunId] = {
          ...draft[action.assistantRunId],
          loading: true,
          loadingError: '',
        };
        break;
      }
      case AssistantRunActionType.GET_ASSISTANT_RUN_OK: {
        draft[action.assistantRunId].loading = false;
        break;
      }
      case AssistantRunActionType.GET_ASSISTANT_RUN_ERROR: {
        draft[action.assistantRunId].loading = false;
        draft[action.assistantRunId].loadingError = action.error;
        break;
      }
      case AssistantRunActionType.DELETE_ASSISTANT_RUN: {
        draft[action.assistantRunId] = {
          ...draft[action.assistantRunId],
          deleting: true,
          deletingError: '',
        };
        break;
      }
      case AssistantRunActionType.DELETE_ASSISTANT_RUN_OK: {
        draft[action.assistantRunId].deleting = false;
        break;
      }
      case AssistantRunActionType.DELETE_ASSISTANT_RUN_ERROR: {
        draft[action.assistantRunId].deleting = false;
        draft[action.assistantRunId].deletingError = action.error;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({ loading, loadingError, byId });
